/* Bardwell & Rye — storefront behaviour (size finder, cart tiers, hero film, FAQ, reviews) */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------------- Size Finder ---------------- */
  var ORDER = ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', '3XL', '4XL', '5XL'];
  function normSize(v) {
    var s = String(v).trim().toUpperCase().replace(/\s+/g, '');
    if (s === '2XL') return 'XXL';
    if (s === 'XXXL') return '3XL';
    if (s === 'XXXXL') return '4XL';
    return s;
  }
  var US_TO_EU = { 4: 34.5, 4.5: 35, 5: 35.5, 5.5: 36, 6: 36.5, 6.5: 37, 7: 37.5, 7.5: 38, 8: 38.5, 8.5: 39, 9: 39.5, 9.5: 40, 10: 40.5, 10.5: 41, 11: 41.5, 11.5: 42, 12: 42.5, 13: 43.5 };
  var EU_LIST = [35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46];
  function euToUs(eu, men) {
    if (men) return Math.round(((eu - 33) / 1.27 - 0.5) * 2) / 2 + 0.5;
    var best = 7, d = 99;
    Object.keys(US_TO_EU).forEach(function (k) { var dd = Math.abs(US_TO_EU[k] - eu); if (dd < d) { d = dd; best = parseFloat(k); } });
    return best;
  }

  function SizeFinder(root) {
    this.root = root;
    this.form = $('[data-sf-form]', root);
    this.gender = root.dataset.gender;
    this.family = root.dataset.family;
    this.isShoe = this.family === 'shoes';
    this.values = (root.dataset.values || '').split('|').filter(Boolean);
    this.steps = $$('.br-sf__step', root).filter(function (s) { return s.dataset.step !== 'result'; });
    this.idx = 0;
    this.rec = null;
    this.bind();
    if (this.isShoe) this.fillShoeSelect('us');
  }
  SizeFinder.prototype.bind = function () {
    var self = this, r = this.root;
    $$('[data-sf-close]', r).forEach(function (b) { b.addEventListener('click', function () { self.close(); }); });
    $('[data-sf-next]', r).addEventListener('click', function () { self.next(); });
    $('[data-sf-back]', r).addEventListener('click', function () { self.back(); });
    $('[data-sf-add]', r).addEventListener('click', function () { self.add(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !r.hidden) self.close(); });
    $$('input[name="units"]', r).forEach(function (i) {
      i.addEventListener('change', function () {
        $$('[data-units]', r).forEach(function (g) { g.hidden = g.dataset.units !== i.value; });
      });
    });
    $$('input[name="system"]', r).forEach(function (i) { i.addEventListener('change', function () { self.fillShoeSelect(i.value); }); });
    $$('.br-sf__cards input', r).forEach(function (i) { i.addEventListener('change', function () { if (self.idx < self.steps.length - 1 && i.closest('.br-sf__step').querySelectorAll('.br-sf__cards').length === 1) setTimeout(function () { self.next(); }, 220); }); });
  };
  SizeFinder.prototype.fillShoeSelect = function (sys) {
    var sel = $('[data-sf-shoe-select]', this.root); if (!sel) return;
    var men = this.gender === 'men', html = '';
    if (sys === 'eu') { EU_LIST.forEach(function (v) { html += '<option value="' + v + '"' + (v === (men ? 42 : 38) ? ' selected' : '') + '>EU ' + v + '</option>'; }); }
    else { for (var v = men ? 6 : 4; v <= (men ? 14 : 12); v += 0.5) { html += '<option value="' + v + '"' + (v === (men ? 10 : 7.5) ? ' selected' : '') + '>US ' + (men ? "Men's " : "Women's ") + v + '</option>'; } }
    sel.innerHTML = html;
  };
  SizeFinder.prototype.open = function () {
    this.root.hidden = false; document.documentElement.classList.add('br-sf-open');
    this.idx = 0; this.render();
    var f = this.root.querySelector('input:not([type=radio]), select'); if (f) setTimeout(function () { f.focus(); }, 60);
  };
  SizeFinder.prototype.close = function () { this.root.hidden = true; document.documentElement.classList.remove('br-sf-open'); };
  SizeFinder.prototype.render = function () {
    var self = this, total = this.steps.length;
    this.steps.forEach(function (s, i) { s.classList.toggle('is-active', i === self.idx); });
    var res = $('.br-sf__result', this.root);
    var done = this.idx >= total;
    res.classList.toggle('is-active', done);
    $('[data-sf-nav]', this.root).hidden = false;
    $('[data-sf-back]', this.root).hidden = this.idx === 0;
    $('[data-sf-next]', this.root).hidden = done;
    $('[data-sf-next]', this.root).textContent = this.idx === total - 1 ? 'See my size' : 'Continue';
    $('[data-sf-bar]', this.root).style.width = Math.min(100, ((this.idx + 1) / (total + 1)) * 100) + '%';
  };
  SizeFinder.prototype.val = function (name) {
    var el = this.form.querySelector('[name="' + name + '"]:checked') || this.form.querySelector('[name="' + name + '"]');
    return el ? el.value : '';
  };
  SizeFinder.prototype.next = function () {
    if (!this.isShoe && this.idx === 0) {
      var metric = this.val('units') === 'metric';
      var w = parseFloat(metric ? this.val('kg') : this.val('lb'));
      var err = $('[data-sf-error]', this.root);
      var ok = metric ? (w >= 35 && w <= 180 && parseFloat(this.val('cm')) >= 140) : (w >= 80 && w <= 400);
      err.hidden = ok;
      if (!ok) { err.textContent = metric ? 'Please enter your height (cm) and weight (kg) to continue.' : 'Please enter your weight in pounds to continue.'; return; }
    }
    this.idx++;
    if (this.idx >= this.steps.length) this.compute();
    this.render();
  };
  SizeFinder.prototype.back = function () { if (this.idx > 0) { this.idx--; this.render(); } };
  SizeFinder.prototype.compute = function () {
    var rec, why;
    if (this.isShoe) {
      var men = this.gender === 'men';
      var base = parseFloat(this.val('shoe_size'));
      if (this.val('system') === 'eu') base = euToUs(base, men);
      var adj = parseFloat(this.val('width') || 0) + parseFloat(this.val('extra') || 0);
      adj = Math.max(-0.5, Math.min(1, adj));
      var target = base + adj;
      rec = this.nearestNumeric(target);
      why = 'Based on your usual US ' + base + (adj > 0 ? ', sized up ' + adj + ' for comfort' : adj < 0 ? ', sized down for a narrow foot' : '') + '. This style runs true to size.';
    } else {
      var metric = this.val('units') === 'metric', hIn, lb;
      if (metric) { hIn = parseFloat(this.val('cm')) / 2.54; lb = parseFloat(this.val('kg')) * 2.2046; }
      else { hIn = parseInt(this.val('ft'), 10) * 12 + parseInt(this.val('in'), 10); lb = parseFloat(this.val('lb')); }
      var bmi = 703 * lb / (hIn * hIn);
      var cuts = this.gender === 'men' ? [19.5, 21.5, 24, 26.8, 29.5, 32.5, 35.5] : [18, 19.8, 22.2, 25.2, 28.5, 32, 35.5];
      var i = 0; while (i < cuts.length && bmi >= cuts[i]) i++;
      var score = i + 0.0; // 0=XXS..7=4XL
      if (hIn >= (this.gender === 'men' ? 74 : 69.5)) score += 0.5;
      if (hIn <= (this.gender === 'men' ? 66 : 61.5)) score -= 0.4;
      score += parseFloat(this.val('build') || 0) + parseFloat(this.val('fit') || 0) + parseFloat(this.val('extra') || 0) * (this.family === 'outerwear' ? 1 : 0.8);
      if (this.root.dataset.oversized === 'true') score -= 0.5;
      var idx = Math.max(1, Math.min(ORDER.length - 1, Math.round(score)));
      rec = this.nearestLetter(ORDER[idx]);
      var hTxt = metric ? Math.round(hIn * 2.54) + ' cm' : Math.floor(hIn / 12) + '′' + Math.round(hIn % 12) + '″';
      var wTxt = metric ? Math.round(lb / 2.2046) + ' kg' : Math.round(lb) + ' lb';
      why = 'Based on ' + hTxt + ', ' + wTxt + ' and your fit preferences' + (this.root.dataset.oversized === 'true' ? ' — this style is cut generously, so we sized down slightly.' : '.') + (this.family === 'outerwear' ? ' Leaves room for knitwear underneath.' : '');
    }
    this.rec = rec;
    $('[data-sf-size]', this.root).textContent = rec || '—';
    $('[data-sf-why]', this.root).textContent = why;
    this.renderChips();
    this.setAdd(rec);
    var mail = $('[data-sf-mail]', this.root);
    mail.href = 'mailto:' + this.root.dataset.email + '?subject=' + encodeURIComponent('Size advice: ' + this.root.dataset.product) + '&body=' + encodeURIComponent('Hello Bardwell & Rye,\n\nCould you help me choose a size?\nThe Size Finder suggested: ' + rec + '\nMy usual size: \nHeight / weight: \n\nThank you!');
  };
  SizeFinder.prototype.nearestLetter = function (target) {
    var vals = this.values.map(normSize);
    if (vals.indexOf(target) > -1) return this.values[vals.indexOf(target)];
    var ti = ORDER.indexOf(target), best = null, bd = 99;
    vals.forEach(function (v, k) { var vi = ORDER.indexOf(v); if (vi < 0) return; var d = Math.abs(vi - ti) + (vi < ti ? 0.1 : 0); if (d < bd) { bd = d; best = k; } });
    return best === null ? this.values[0] : this.values[best];
  };
  SizeFinder.prototype.nearestNumeric = function (target) {
    var best = null, bd = 99;
    this.values.forEach(function (v) { var n = parseFloat(v); if (isNaN(n)) return; if (n > 30) n = euToUs(n, false); var d = Math.abs(n - target) + (n < target ? 0.01 : 0); if (d < bd) { bd = d; best = v; } });
    return best === null ? String(target) : best;
  };
  SizeFinder.prototype.renderChips = function () {
    var self = this, wrap = $('[data-sf-chips]', this.root); wrap.innerHTML = '';
    this.values.forEach(function (v) {
      var b = document.createElement('button'); b.type = 'button'; b.className = 'br-sf__chip' + (v === self.rec ? ' is-on' : ''); b.textContent = v;
      b.addEventListener('click', function () { self.rec = v; $$('.br-sf__chip', wrap).forEach(function (c) { c.classList.toggle('is-on', c === b); }); self.setAdd(v); });
      wrap.appendChild(b);
    });
  };
  SizeFinder.prototype.sizeInput = function (v) {
    var name = this.root.dataset.option;
    return $$('input[data-variant-input]').filter(function (i) { return i.name === name && i.value === v && i.getAttribute('form') === this.root.dataset.form; }, this)[0];
  };
  SizeFinder.prototype.setAdd = function (v) {
    $('[data-sf-add-size]', this.root).textContent = v;
    var inp = this.sizeInput(v);
    var so = inp && inp.classList.contains('disabled');
    $('[data-sf-soldout]', this.root).hidden = !so;
  };
  SizeFinder.prototype.add = function () {
    var self = this, inp = this.sizeInput(this.rec);
    if (inp) { inp.checked = true; inp.click(); inp.dispatchEvent(new Event('change', { bubbles: true })); }
    $$('.br-sf-trigger').forEach(function (t) { t.setAttribute('data-sf-picked', self.rec); });
    setTimeout(function () {
      var form = document.getElementById(self.root.dataset.form);
      var btn = form && form.querySelector('[data-add-to-cart]');
      if (btn && !btn.disabled) { self.close(); btn.click(); }
      else { $('[data-sf-soldout]', self.root).hidden = false; }
    }, 260);
  };

  function initSizeFinder() {
    var root = document.getElementById('BrSizeFinder');
    if (!root || root.__sf) return;
    root.__sf = new SizeFinder(root);
    document.body.appendChild(root);
    document.addEventListener('click', function (e) {
      var t = e.target.closest && e.target.closest('[data-sf-open]');
      if (t) { e.preventDefault(); root.__sf.open(); }
    });
  }

  /* ---------------- Cart tier progress (2 = 10%, 3 = 15%, 4+ = 20%) ---------------- */
  function updateTiers(count) {
    $$('[data-br-tier]').forEach(function (bar) {
      var fill = $('.br-tier__fill', bar), msg = $('.br-tier__msg', bar);
      var pct = count <= 1 ? (count === 1 ? 8 : 0) : count === 2 ? 34 : count === 3 ? 67 : 100;
      if (fill) fill.style.width = pct + '%';
      $$('.br-tier__step', bar).forEach(function (s) { s.classList.toggle('is-on', count >= parseInt(s.dataset.qty, 10)); });
      if (msg) {
        if (count <= 0) msg.innerHTML = 'Mix &amp; match any styles — save up to <b>20%</b>';
        else if (count === 1) msg.innerHTML = 'Add <b>1 more item</b> to save <b>10%</b>';
        else if (count === 2) msg.innerHTML = '<b>10% off</b> unlocked · add 1 more for <b>15%</b>';
        else if (count === 3) msg.innerHTML = '<b>15% off</b> unlocked · add 1 more for <b>20%</b>';
        else msg.innerHTML = 'You’ve unlocked our best saving: <b>20% off</b>';
      }
    });
    $$('[data-br-cart-count]').forEach(function (el) { el.textContent = count > 0 ? '(' + count + ')' : ''; });
  }
  function refreshCart() {
    fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) { updateTiers(c.item_count); }).catch(function () {});
  }
  function initTiers() {
    var bar = $('[data-br-tier]');
    if (!bar) return;
    updateTiers(parseInt(bar.dataset.count, 10) || 0);
    ['cart:updated', 'ajaxProduct:added', 'cart:open', 'cartdrawer:opened'].forEach(function (ev) { document.addEventListener(ev, function () { setTimeout(refreshCart, 350); }); });
    var products = $('#CartDrawer [data-products]');
    if (products && 'MutationObserver' in window) {
      var t; new MutationObserver(function () { clearTimeout(t); t = setTimeout(refreshCart, 250); }).observe(products, { childList: true, subtree: true });
    }
  }

  /* ---------------- Hero film (sequential clips, desktop/mobile sets) ---------------- */
  function initHero(root) {
    var vids = $$('video[data-br-clip]', root);
    if (!vids.length) return;
    var mq = window.matchMedia('(max-width: 768px)');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var srcs = function () {
      var key = mq.matches ? 'mobile' : 'desktop';
      try { return JSON.parse(root.getAttribute('data-' + key) || '[]'); } catch (e) { return []; }
    };
    var list = srcs(), i = 0, active = 0, playing = !reduce;
    if (!list.length) return;
    function load(v, src) { if (v.getAttribute('src') !== src) { v.setAttribute('src', src); v.load(); } }
    function show(n) {
      var cur = vids[active], nxt = vids[1 - active];
      load(nxt, list[n % list.length]);
      var go = function () {
        nxt.currentTime = 0;
        var p = nxt.play(); if (p && p.catch) p.catch(function () {});
        nxt.classList.add('is-on'); cur.classList.remove('is-on');
        active = 1 - active; i = n % list.length;
        $$('[data-br-dot]', root).forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
      };
      if (nxt.readyState >= 2) go(); else nxt.addEventListener('loadeddata', go, { once: true });
    }
    load(vids[0], list[0]); vids[0].classList.add('is-on');
    if (playing) { var p0 = vids[0].play(); if (p0 && p0.catch) p0.catch(function () {}); }
    vids.forEach(function (v) { v.addEventListener('ended', function () { if (playing && v.classList.contains('is-on')) show(i + 1); }); });
    var btn = $('[data-br-toggle]', root);
    if (btn) btn.addEventListener('click', function () {
      playing = !playing; var v = vids[active];
      if (playing) { v.play(); btn.classList.remove('is-paused'); btn.setAttribute('aria-label', 'Pause video'); }
      else { v.pause(); btn.classList.add('is-paused'); btn.setAttribute('aria-label', 'Play video'); }
    });
    if (reduce && btn) { btn.classList.add('is-paused'); }
    mq.addEventListener && mq.addEventListener('change', function () { list = srcs(); i = 0; load(vids[active], list[0]); if (playing) vids[active].play(); });
  }

  /* ---------------- FAQ tabs ---------------- */
  function initFaq(root) {
    var tabs = $$('[data-faq-tab]', root);
    tabs.forEach(function (t) {
      t.addEventListener('click', function () {
        tabs.forEach(function (x) { x.setAttribute('aria-selected', x === t ? 'true' : 'false'); });
        $$('[data-faq-panel]', root).forEach(function (p) { p.hidden = p.dataset.faqPanel !== t.dataset.faqTab; });
      });
    });
  }

  /* ---------------- Review video tiles & sliders ---------------- */
  function initReviews(root) {
    $$('[data-br-rv]', root).forEach(function (w) {
      var v = $('video', w), b = $('button', w);
      if (!v || !b) return;
      b.addEventListener('click', function () { if (v.paused) { v.play(); w.classList.add('is-playing'); } else { v.pause(); w.classList.remove('is-playing'); } });
      v.addEventListener('ended', function () { w.classList.remove('is-playing'); });
    });
  }
  function initSliders(root) {
    $$('[data-br-slider]', root).forEach(function (s) {
      var track = $('[data-br-track]', s);
      $$('[data-br-prev],[data-br-next]', s).forEach(function (b) {
        b.addEventListener('click', function () {
          var dir = b.hasAttribute('data-br-next') ? 1 : -1;
          track.scrollBy({ left: dir * track.clientWidth * 0.85, behavior: 'smooth' });
        });
      });
    });
  }

  function initAll(scope) {
    scope = scope || document;
    initSizeFinder();
    $$('[data-br-hero]', scope).forEach(initHero);
    $$('[data-br-faq]', scope).forEach(initFaq);
    $$('[data-br-reviews]', scope).forEach(initReviews);
    initSliders(scope);
  }
  document.addEventListener('DOMContentLoaded', function () { initAll(); initTiers(); });
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
